import React, { useImperativeHandle, useRef, useCallback, useState } from 'react';
import SessionKeys from '../../session'
import { api, STATUS_OK, STATUS_NO_CONTENT, STATUS_BAD_REQUEST, STATUS_NOT_FOUND } from '../../server/api.js';

export async function isCacheNear(idZec, latitude, longitude, distance) {
    return await api.get(`Cache/getValidationCache?idZec=${idZec}&latitude=${latitude}&longitude=${longitude}&distance=${distance}`);
}

export function ValideCoordinateCache(latitude, longitude) {

    let message = '';
    let idZec = 'zec-bsl';
    let inZEC = true;

    //LECTURE DISTANCE MINIMUM
    let distance = parseInt(sessionStorage.getItem(SessionKeys.DISTANCE_MINIMUM_CACHE));

    //LECTURE COORDONNE MIN ET MAX
    let longitudeMin = parseFloat(sessionStorage.getItem(SessionKeys.CACHE_COORDINATE_MINLNG));
    let longitudeMax = parseFloat(sessionStorage.getItem(SessionKeys.CACHE_COORDINATE_MAXLNG));

    //possible que les valeurs soit négatives dans la config
    if (longitudeMax < longitudeMin) {
        longitudeMin = longitudeMax;
        longitudeMax = parseFloat(sessionStorage.getItem(SessionKeys.CACHE_COORDINATE_MAXLNG));
    }

    let latitudeMin = parseFloat(sessionStorage.getItem(SessionKeys.CACHE_COORDINATE_MINLAT));
    let latitudeMax = parseFloat(sessionStorage.getItem(SessionKeys.CACHE_COORDINATE_MAXLAT));

    //possible si les valeurs sont négatives dans la config
    if (latitudeMax < latitudeMin) {
        latitudeMin = latitudeMax;
        latitudeMax = parseFloat(sessionStorage.getItem(SessionKeys.CACHE_COORDINATE_MAXLAT));
    }

    if (longitude < longitudeMin || longitude > longitudeMax)
        inZEC = false;

    if (latitude < latitudeMin || latitude > latitudeMax)
        inZEC = false;

    //VERIFIE SI COORDONNE DANS LE MINIMUM ET MAXIMUM
    //SI ERREUR
    if (inZEC !== true) {
        let error = "Assurez vous que la latitude " + latitude + " est comprise entre " + latitudeMin + " et " + latitudeMax
            + " et la longitude " + longitude + " est comprise entre " + longitudeMin + " et " + longitudeMax;
        return [false, error];
    }
    else {
        //VERIFIE SI LA CACHE EST TROP PRET D'UN AUTRE
        //await isCacheNear(idZec, latitude, longitude, distance).then((distanceProche) => {
        //    if (distanceProche !== 0) {
        //        //Ces coordonnées se situent trop prêt d'une cache déjà enrégistrée.
        //        let error = "Ces coordonnées se situent trop prêt d'une cache déjà enrégistrée.";
        //        error = error + "Distance: " + distanceProche + " mètres.";
        //        return [false, error];
        //    }
        //    });

       // const calculDistance = await api.get(`Cache/getValidationCache?idZec=${idZec}&latitude=${latitude}&longitude=${longitude}&distance=${distance}`, false).then(result => {
       //     if (result.status !== STATUS_OK)
       //         return ["Une erreur s'est produite et la vérification na pas pu être faite."];

       //     return result.json();
       // }).then(distanceProche => {
       //     if (distanceProche !== 0) {
       //         //Ces coordonnées se situent trop prêt d'une cache déjà enrégistrée.
       //         let error = "Ces coordonnées se situent trop prêt d'une cache déjà enrégistrée.";
       //         error = error + "Distance: " + distanceProche + " mètres.";
       //         return [error];
       //     };
       // });
       //const fin = calculDistance(distanceProche).then(distanceProche => {
       //     if (distanceProche == "") {
       //         //Ces coordonnées se situent trop prêt d'une cache déjà enrégistrée.
       //         return [true, ""];
       //     }
       //     else { return [false, distanceProche]; };
       // });

    //    await api.get(`Cache/getValidationCache?idZec=${idZec}&latitude=${latitude}&longitude=${longitude}&distance=${distance}`, false).then(result => {
    //        if (!result.keyValue !== 0) {
    //            const distanceProche = !result.keyValue;
    //            //Ces coordonnées se situent trop prêt d'une cache déjà enrégistrée.
    //            let error = "Ces coordonnées se situent trop prêt d'une cache déjà enrégistrée.";
    //            error = error + "Distance: " + distanceProche + " mètres.";
    //            message = error;
    //        };
    //    }).then(() => {
    //        if (message !== '') {
    //            return [false, message]
    //        }
    //        else {
    //            return [true, '']
    //        }
    //    });

        return [true, ''];
    }

}

